import { useQuery } from 'react-query';
import {
  HolidayReportItem,
  HolidayType
} from 'mdello-client-ts/dist/src/interfaces/providers/intranet/holiday/holiday';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';

const fetchHolidays = async (type: HolidayType): Promise<HolidayReportItem[] | undefined> => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  const data = await getClient()?.getHolidayBalance(currentProject._id, type);

  return data;
};

export const useGetHolidays = (type: HolidayType) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.HOLIDAY_TYPES, type], () => fetchHolidays(type), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
